import React, { useEffect, useRef } from 'react';

const FormScrollDown = ({ subject }) => {
  const formRef = useRef(null);

  useEffect(() => {
    if (subject && formRef.current) {
      formRef.current.scrollIntoView();
    }
  }, [subject, formRef.current]);

  return <div ref={formRef} />;
};

export default FormScrollDown;
